import React, { useState } from "react";
import { motion } from "framer-motion";
import { animationValues, transitionValues } from "../utils/pageTransitions";
import logo from "../assets/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import {
  adminLogin,
  forgot_password,
  reset_password,
} from "../redux/actions/adminActions";
import { connect } from "react-redux";
import Spinner from "../components/reusables/spinner";
import InputField from "../components/reusables/input";
import "../styles/auth.css";

function ResetPassword({ reset_password, reset_email, reset_code }) {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShow] = useState(false);

  const [formData, setData] = useState({
    email: "",
    newPassword: "",
    confirmNewPassword: "",
    token: "",
  });

  const handleChange = (e) => {
    setData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLoading = () => {
    setIsLoading(true);
  };

  const done = () => {
    setIsLoading(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLoading();
    let data = {
      ...formData,
      ...{ email: reset_email, token: reset_code },
    };
    reset_password(data, navigate, done);
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="fullHeight admin">
        <div className="formHolder container center">
          <div className="content vAlign">
            <img src={logo} alt="" className="mAuto pb-5" />
            <div className="authCard vAlign">
              <h2 className="sectionHead--small textIsBold pt-3 mx-4">
                Reset Password
              </h2>

              <form className="pt-3" onSubmit={handleSubmit}>
                <div className="pt-2 pb-2">
                  <InputField
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={handleChange}
                    placeholder="Password"
                    type={showPassword ? "text" : "password"}
                    icon
                    iconClass={
                      showPassword ? "ri-eye-line" : "ri-eye-close-line"
                    }
                    iconClick={() => setShow(!showPassword)}
                  />
                </div>

                <div className="pt-2 pb-2">
                  <InputField
                    name="confirmNewPassword"
                    value={formData.confirmNewPassword}
                    onChange={handleChange}
                    placeholder="Confirm Password"
                    type={showPassword ? "text" : "password"}
                    icon
                    iconClass={
                      showPassword ? "ri-eye-line" : "ri-eye-close-line"
                    }
                    iconClick={() => setShow(!showPassword)}
                  />
                </div>

                <div className="">
                  <div className="pt-3">
                    <button
                      className="btn__filled center textIsBold w-100"
                      disabled={isLoading}
                    >
                      {isLoading ? <Spinner /> : "Reset Password"}
                    </button>
                  </div>
                </div>
              </form>

              <div className="mt-3">
                <Link to="/login">
                  <span className="textIsGreen sectionText">Login</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  reset_email: state.admin.reset_email,
  reset_code: state.admin.reset_code,
});

const mapDispatchToProps = (dispatch) => ({
  reset_password: (data, navigator, done) =>
    dispatch(reset_password(data, navigator, done)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
